import { PropsWithChildren, useEffect, useMemo, useRef, useState } from "react"
import classes from './ScrollInTransition.module.scss';

export type ScrollInTransitionPresets = 'flyToLeft' | 'flyToRight' | 'opacity';

export type ScrollInTransitionProps = PropsWithChildren & {
  preset: ScrollInTransitionPresets;
  triggerOffset?: number;
}

export const ScrollInTransition = (props: ScrollInTransitionProps) => {
  const { children, preset, triggerOffset = 0 } = props;
  const elementRef = useRef<HTMLSpanElement | null>(null);
  const [top, setTop] = useState<number>();
  const [isActivated, setIsActivated] = useState(false);
  useEffect(() => {
    if (elementRef.current) {
      const rect = elementRef.current.getBoundingClientRect();
      setTop(rect.top);
    }
  }, [])
  useEffect(() => {
    const onScroll = () => {
      if (top === undefined) {
        return;
      }
      const y = window.scrollY;
      if (y > top - window.innerHeight / 2 - triggerOffset) {
        setIsActivated(true);
        window.removeEventListener('scroll', onScroll);
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    }
  }, [top, triggerOffset])

  const classNames = useMemo(() => {
    const result = [classes.scrolInTransition, classes[preset]];
    if (isActivated) {
      result.push(classes.activated);
    }
    return result.join(' ');
  }, [isActivated, preset])

  return <span ref={elementRef} className={classNames}>
    {children}
  </span>
}